module.exports = __webpack_public_path__ + "img/icon-not-currently.0149b187.svg";